// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"329":"78fe5d67","550":"0796a618","713":"289ba0e6","787":"6d891bca"}[chunkId] + ".chunk.js";
};